
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/okta-alternative",
      function () {
        return require("private-next-pages/compare/okta-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/okta-alternative"])
      });
    }
  